import { useEffect, useState } from "react";
import styles from "../addBooking.module.css";
import { Delete } from "@mui/icons-material";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import axios from "axios";
import { authData } from "../../../../components/GetAuth";
import { NumericFormat } from "react-number-format";

const DeliveryProductComponent = ({ fileds, append, errors, control, setValue, register, clearErrors, watch, cngProductVal, delItems }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [deliveryProductList, setDeliveryProductList] = useState([]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + "v1/delivery-product-dd-list", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then((response) => {
            if (response.data.status === "SUCCESS") {
                let allData = response.data.data;
                allData = allData.concat([{ id: 0, title: 'Other' }]);
                setDeliveryProductList(allData);
            }
        });
    }, [API_TOKEN]);

    return (<div className={`${styles.BookADelivery}`}>
        <div className={`${styles.BookADeliveryCardArea}`}>
            {fileds.map((item, index) => {
                return (<div className={`${styles.BookDeliveryCard}`} key={item.id} style={{ background: "#D1E7FC" }}>
                    <div className={`${styles.BookDeliveryCardUnder}`}>
                        <div className={`${styles.BookDeliveryCardUnderRow}`}>
                            <div className={`${styles.BookDeliveryFormCard25}`}>
                                <div className={`FormHalfGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel>Category*</InputLabel>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`delivery_products[${index}].category_id`, { required: true })}
                                            render={({ field }) => (<Select
                                                {...field}
                                                label="Category*"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    if (e.target.value) {
                                                        let selCat = deliveryProductList?.filter((i) => i?.id === e.target.value);
                                                        if (selCat.length) {
                                                            selCat = selCat[0];
                                                            if (selCat?.no_of_child === 0) {
                                                                setValue(`delivery_products[${index}].item_id`, selCat?.id);
                                                                setValue(`delivery_products[${index}].item_name`, selCat?.title);
                                                                setValue(`delivery_products[${index}].total`, selCat?.amount);
                                                                setValue(`delivery_products[${index}].price`, selCat?.amount);
                                                                setValue(`delivery_products[${index}].quantity`, 1);
                                                                setValue(`delivery_products[${index}].is_item`, false);
                                                            } else {
                                                                setValue(`delivery_products[${index}].item_id`, "");
                                                                setValue(`delivery_products[${index}].item_name`, "");
                                                                setValue(`delivery_products[${index}].total`, "");
                                                                setValue(`delivery_products[${index}].is_item`, true);
                                                                setValue(`delivery_products[${index}].price`, "");
                                                            }
                                                            clearErrors();
                                                        }
                                                        cngProductVal();
                                                    } else {
                                                        setValue(`delivery_products[${index}].item_id`, 0);
                                                        setValue(`delivery_products[${index}].item_name`, "");
                                                        setValue(`delivery_products[${index}].quantity`, 1);
                                                        setValue(`delivery_products[${index}].total`, "");
                                                        setValue(`delivery_products[${index}].price`, "");
                                                    }
                                                }}
                                            >
                                                {deliveryProductList?.map((val) => {
                                                    return (val?.parent_id === 0 || val?.id === 0) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                                })}
                                            </Select>)}
                                        />
                                    </FormControl>
                                    {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.category_id && (<p className={`${styles.ErrorM}`}>Please select category</p>)}
                                </div>
                            </div>

                            <div className={`${styles.BookDeliveryFormCard25}`}>
                                {watch(`delivery_products[${index}].category_id`) === 0 && (<div className={`FormHalfGroup`}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`delivery_products[${index}].item_name`, { required: true })}
                                        render={({ field }) => (<TextField
                                            {...field}
                                            label="Item*"
                                            variant="outlined"
                                            onChange={(e) => {
                                                field.onChange(e);
                                            }}
                                        />)}
                                    />
                                    {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.item_name && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                                </div>)}
                                {(watch(`delivery_products[${index}].is_item`) && watch(`delivery_products[${index}].category_id`) !== 0) && (<div className={`FormHalfGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel>Item*</InputLabel>
                                        <Controller
                                            key={item.id}
                                            control={control}
                                            {...register(`delivery_products[${index}].item_id`, { required: true })}
                                            render={({ field }) => (<Select
                                                {...field}
                                                label="Item*"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    if (e.target.value) {
                                                        let selProduct = deliveryProductList?.filter((i) => i?.id === e.target.value);
                                                        if (selProduct.length) {
                                                            selProduct = selProduct[0];
                                                            setValue(`delivery_products[${index}].item_name`, selProduct?.parent?.title + "- " + selProduct?.title);
                                                            setValue(`delivery_products[${index}].total`, selProduct?.amount);
                                                            setValue(`delivery_products[${index}].price`, selProduct?.amount);
                                                            setValue(`delivery_products[${index}].quantity`, 1);
                                                            clearErrors();
                                                        }
                                                    }
                                                    cngProductVal();
                                                }}
                                            >
                                                {deliveryProductList?.map((val) => {
                                                    return val?.parent_id === watch(`delivery_products[${index}].category_id`) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                                })}
                                            </Select>)}
                                        />
                                    </FormControl>
                                    {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.item_id && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                                </div>)}
                            </div>

                            <div className={`${styles.BookDeliveryFormCard20}`}>
                                <div className={`${styles.FormField}`}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`delivery_products[${index}].quantity`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            label="Quantity*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={0}
                                            fixedDecimalScale
                                            onChange={(e) => {
                                                field.onChange(e);

                                                if (watch(`delivery_products[${index}].category_id`) !== 0) {
                                                    let priceAmnt = watch(`delivery_products[${index}].price`);
                                                    let quantityAmnt = parseInt(e.target.value);
                                                    if (quantityAmnt > 0 && !isNaN(quantityAmnt)) {
                                                        setValue(`delivery_products[${index}].total`, priceAmnt * quantityAmnt);
                                                    }
                                                }

                                                cngProductVal();
                                            }}
                                        />)}
                                    />
                                    {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.quantity && (<p className={`${styles.ErrorM}`}>Please enter quantity</p>)}
                                </div>
                            </div>

                            <div className={`${styles.BookDeliveryFormCard20}`}>
                                <div className={`${styles.FormField}`}>
                                    <Controller
                                        key={item.id}
                                        control={control}
                                        {...register(`delivery_products[${index}].total`, { required: true })}
                                        render={({ field }) => (<NumericFormat
                                            {...field}
                                            label="Total*"
                                            variant="outlined"
                                            customInput={TextField}
                                            allowLeadingZeros={false}
                                            allowNegative={false}
                                            decimalScale={2}
                                            fixedDecimalScale
                                            onChange={(e) => {
                                                field.onChange(e);
                                                cngProductVal();
                                            }}
                                        />)}
                                    />
                                    {errors?.delivery_products?.length > 0 && errors?.delivery_products[index]?.total && (<p className={`${styles.ErrorM}`}>Please enter total amount</p>)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <button className={`${styles.CardTrashBU}`} type="button" onClick={(e) => { delItems(e); }}><Delete /></button>
                </div>);
            })}

            <button className={`${styles.HomeBU}`} type="button" onClick={() => { append({ category_id: "", item_id: "", item_name: "", total: "", quantity: "", price: "", is_item: true }); }}>Add Items</button>
        </div>
    </div>);
}

export default DeliveryProductComponent;